import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { ScreeningState } from '@app/store/screening/screening.state';
import { IuploadFilesRequest } from '@shared/interfaces/result.interface';
import { ToastrService } from 'ngx-toastr';
import { IpsRequestsService } from '@app/ips/services/ips-requests.service';
import { EMPTY, catchError, concat, forkJoin, tap } from 'rxjs';
import Utils from '@app/shared/utils/utils';
import { FilesTypeEnum } from '@app/ips/models/enum/files-type.enum';
import { ScreeningService } from '@app/store/screening/screening.service';
import { IScreeningResultResponse } from '../../models/screening-result-response.interface';
import { FileUploadService } from '@app/shared/services/file-upload/file-upload.service';
import { Convert } from '@app/shared/utils/ConvertMimeTypes';

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./_result.component.sass', '../../screening.sass'],
})
export class ResultComponent implements OnInit {
  @Input() private nextStep: any;
  @Output() completedChange = new EventEmitter<boolean>();
  @Output() hasDivergenceReportChange = new EventEmitter<boolean>();

  tradeInfo!: IScreeningResultResponse;
  hasDivergenceReport = false;
  idTrade: string;
  isImageSaved = false;
  inputs: any;
  private files: string[] = [];

  constructor(
    private _store: Store,
    private _router: Router,
    private _toastrService: ToastrService,
    private _requestsService: IpsRequestsService,
    private _screeningService: ScreeningService,
    private uploadService: FileUploadService
  ) {}

  ngOnInit(): void {
    const { idTrade } = this._store.selectSnapshot(ScreeningState);
    this.completedChange.emit(true);
    this.idTrade = idTrade;
    this._getChecklistAvalliationResult();
  }

  onChangeFiles(eventFileList: Array<string>) {
    if (!!eventFileList.length) {
      this.files = eventFileList;
    }
  }

  resetScreening() {
    this._screeningService.resetScreening(this.idTrade).subscribe(() => {
      this._router.navigate(['ips', 'triagem', 'buscar']);
    });
  }

  goToDivergenceReport() {
    this.completedChange.emit(true);
    this.nextStep();
  }

  async finalize() {
    try {
      const uploadRequests = this.files.map(async (file) => {
        const payload: IuploadFilesRequest = {
          tradeId: this.idTrade,
          file,
          nameFile: this.filenameGenerator(file),
          keyMidia: Utils.newGuid(),
          type: FilesTypeEnum.Image,
          currentPart: 1,
          lastPart: 1,
        };

        const contentType = file.startsWith('data:') ? file.substring(5, file.indexOf(';')) : null;
        const filename = `${this.idTrade}/${this.filenameGenerator(file)}`;

        const informatiosUpload = {
          idTrade: this.idTrade,
          filename,
          contentType,
        };

        const response = await this.uploadService
          .postGeneratePresignedUrlUpload(informatiosUpload, 'COLLECT.postGeneratePresignedUrl')
          .toPromise();

        const theFile = await Utils.convertSrcToFile(file, filename);

        await this.uploadService.uploadFile(theFile, response.url).toPromise();
        await this.uploadService
          .updateTradeGallery(
            { idTrade: this.idTrade, filename },
            'COLLECT.postRegisterUploadedMedia'
          )
          .toPromise();
      });

      await Promise.all(uploadRequests);

      await this._requestsService.closeScreening(this.idTrade).toPromise();

      this._toastrService.success('Triagem finalizada com sucesso.');
      this._router.navigate(['ips/triagem/buscar']);
    } catch (error) {
      console.error('Erro ao finalizar a triagem:', error);
      this._toastrService.error(
        'Não foi possível enviar as evidências. Por favor, tente novamente.'
      );
    }
  }

  private filenameGenerator(fileBase64: string) {
    const mimeType = fileBase64.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0];

    return Utils.randomFilenameGenerator('evidencia', Convert.getExtension(mimeType)[0]);
  }

  private _setHasDivergenceReport(isDiverge: boolean, hasDivergenceReason: boolean) {
    this.hasDivergenceReport = hasDivergenceReason && isDiverge;
    this.hasDivergenceReportChange.emit(this.hasDivergenceReport);
  }

  private _getChecklistAvalliationResult() {
    this._screeningService
      .getCheckListResult(this.idTrade)
      .pipe(
        tap((response: IScreeningResultResponse) => {
          const { checklist, diverge, hasDivergenceReason } = response.screening;
          this._setHasDivergenceReport(diverge, hasDivergenceReason);
          const consolidatedAQ = checklist.filter(
            (qa) => qa.answerCustomer !== qa.answerRecertifier
          );
          this.tradeInfo = response;
          this.tradeInfo.screening.checklist = consolidatedAQ;
        })
      )
      .subscribe();
  }
}
